import { Container, Texture, Text, TextStyle, Point } from "pixi.js";
import { GameFont } from "../../../../../common/GameFont";
import { DynamicResourcesPackage } from "../../../../../../../resources/DynamicResourcesPackage";
import { MarketplaceGuestInfo } from "../../models/building/MarketplaceGuestInfo";
import { ICanvasScaler } from "../../../../../../../canvas/ICanvasScaler";
import { Avatar } from "by/gamefactory/cityversetycoon/scenes/common/components/Avatar";
import { UserProfileResourcePackage } from "../../../../userprofile/resources/UserProfileResourcePackage";

export class MarketplaceGuestAvatar extends Container {
    private readonly canvasScaler: ICanvasScaler;
    private avatar: Avatar;
    private firstNameText: Text;

    public constructor(
        avatarTexture: Texture,
        userProfileResources: UserProfileResourcePackage,
        firstName: string,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.canvasScaler = canvasScaler;
        this.avatar = new Avatar(userProfileResources, avatarTexture);
        this.avatar.enabled = false;
        this.avatar.avatarSize = new Point(76, 76);
        this.avatar.glow = true;

        this.firstNameText = new Text(firstName, new NicknameTextStyle());
        this.firstNameText.anchor.set(0.5);
        this.firstNameText.position.set(this.avatar.width + this.firstNameText.width * 0.5 + 15, this.avatar.height * 0.5 + 3);
        this.addChild(this.avatar, this.firstNameText);
    }

    public async updateGuest(guestInfo: MarketplaceGuestInfo): Promise<void> {
        this.firstNameText.text = guestInfo.firstName;
        this.firstNameText.x = this.avatar.width + this.firstNameText.width * 0.5 + 15;
        this.position.x = this.canvasScaler.referenceWidth * 0.5 - this.width * 0.5;
        const texture = await this.loadBuildingTexture(guestInfo.avatar);
        this.avatar.updateTexture(texture);
        this.avatar.glow = true;
    }

    private async loadBuildingTexture(textureUrl: string): Promise<Texture> {
        const cardDynamicResources = new DynamicResourcesPackage();
        cardDynamicResources.add(textureUrl);
        await cardDynamicResources.load();
        return cardDynamicResources.resource(textureUrl);
    }
}

class NicknameTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 62
        }));
    }
}
